import { render, staticRenderFns } from "./RumourPrint.vue?vue&type=template&id=409423a2"
import script from "./RumourPrint.vue?vue&type=script&lang=js"
export * from "./RumourPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('409423a2')) {
      api.createRecord('409423a2', component.options)
    } else {
      api.reload('409423a2', component.options)
    }
    module.hot.accept("./RumourPrint.vue?vue&type=template&id=409423a2", function () {
      api.rerender('409423a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/rumour/RumourPrint.vue"
export default component.exports